export const API_PATH_ApiAlertMgtmAlertConfigGet = '/services/alerts-mgtm/apiAlertMgtmAlertConfigGet';
